/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { MdAccessTime } from "react-icons/md";
import StyledTimePicker from "../../../../../StyledTimePicker";

const TimePickerContainer = styled.div`
  background-color: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 4px;
  height: 250px !important;
  position: absolute;
  right: 0;
  z-index: 99;
`;

const TimeCard = styled.div`
  border: 1px solid #dddddd;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
`;

const Title = styled.div`
  text-align: center;
  font: 14px;
  color: #2f2f2f;
  cursor: pointer;
`;

const Button = styled.div`
  cursor: pointer;
  width: 20px;
  height: 20px;
  position: relative;
`;

interface Props {
  addTime: (date: string) => void;
}

export default function CreateTimeCard(props: Props): JSX.Element {
  const [timeLabel, setTimeLabel] = useState("Choose Time");
  const [step, setStep] = useState<"hour" | "minute">("hour");
  const [isTimePickerActive, setIsTimePickerActive] = useState(true);
  const [newHour, setNewHour] = useState<Date>();

  function handleShowTimePicker() {
    setIsTimePickerActive(!isTimePickerActive);
  }

  useEffect(() => {
    if (newHour && newHour.getMinutes() !== 21) {
      setTimeLabel(
        `${dayjs(newHour).format("LT").toLowerCase()} ${dayjs(newHour).format(
          "(z)"
        )}`
      );
    } else {
      setTimeLabel("Choose Time");
    }
  }, [newHour]);

  return (
    <TimeCard>
      <Title onClick={() => handleShowTimePicker()}>{timeLabel}</Title>

      <Button>
        <MdAccessTime
          onClick={() => handleShowTimePicker()}
          color={"#707070"}
          size={20}
        />

        {isTimePickerActive && (
          <TimePickerContainer>
            <StyledTimePicker
              step={step}
              setStep={setStep}
              goBack={() => {
                handleShowTimePicker();
                setStep("hour");
              }}
              favoriteTime
              date={newHour}
              minuteInterval={5}
              onSelect={async ({ hour, minute }) => {
                let selectedDateTime = dayjs();
                selectedDateTime = selectedDateTime.set(
                  "hours",
                  hour as number
                );
                selectedDateTime = selectedDateTime.set(
                  "minutes",
                  minute as number
                );
                selectedDateTime = selectedDateTime.set("seconds", 0);

                props.addTime(selectedDateTime.toString());
              }}
            />
          </TimePickerContainer>
        )}
      </Button>
    </TimeCard>
  );
}
